import { get, post } from '@/services/Axios';
import qs from 'qs';
import errorHandler from '@/mixins/errorHandler';

export default {
  mixins: [errorHandler],
  data() {
    return {
      announcement: {},
      announcements: [],
      announcementTemplates: [],
      paginationAnnouncements: {},
      paginationAnnouncementTemplates: {},
      loadAnnouncements: true,
      loadAnnouncementTemplates: true,
      loadFormAnnouncement: false,
      loadAnnouncement: false
    };
  },
  methods: {
    async getAnnouncements(...param) {
      this.loadAnnouncements = true;
      const parameter = param[0] || {};
      const params = {
        limit: parameter.limit || 10,
        page: parameter.page || 1,
        sort: parameter.sorts || 'notification_input_datetime',
        dir: parameter.dir || 'DESC',
        filter: []
      };
      if (parameter.filters) {
        params.filter.push(...parameter.filters);
      }
      try {
        const {
          data: { results, pagination }
        } = await get('/notification/list', { params });
        this.announcements = results;
        this.paginationAnnouncements = pagination;
        return results;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadAnnouncements = false;
      }
    },
    async getAnnouncementTemplates(...param) {
      this.loadAnnouncementTemplates = true;
      const parameter = param[0] || {};
      const params = {
        limit: parameter.limit || 10,
        page: parameter.page || 1,
        sort: parameter.sorts || 'notification_input_datetime',
        dir: parameter.dir || 'DESC',
        filter: [
          {
            type: 'string',
            field: 'notification_is_template',
            value: '1'
          }
        ]
      };
      if (parameter.filters) {
        params.filter.push(...parameter.filters);
      }
      try {
        const {
          data: { results, pagination }
        } = await get('/notification/list', { params });
        this.announcementTemplates = results;
        this.paginationAnnouncementTemplates = pagination;
        return results;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadAnnouncementTemplates = false;
      }
    },
    async getAnnouncement(id) {
      this.loadAnnouncement = true;
      const params = {
        notification_id: id
      };
      try {
        const { data } = await get('/notification/detail', { params });
        this.announcement = data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadAnnouncement = false;
      }
    },
    async createAnnouncement(request) {
      this.loadFormAnnouncement = true;
      const requestBody = {
        title: request.title,
        content: request.content,
        // type: request.type,
        // from: request.from,
        // to: request.to,
        is_publish: 1,
        is_template: request.is_template ? 1 : 0
      };
      const payload = qs.stringify(requestBody);
      try {
        const { data } = await post('/notification/create', {
          data: payload
        });
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadFormAnnouncement = false;
      }
    },
    async updateAnnouncement(request, id) {
      this.loadFormAnnouncement = true;
      const requestBody = {
        id,
        title: request.title,
        content: request.content,
        // type: request.type,
        // from: request.from,
        // to: request.to,
        is_publish: 1,
        is_template: request.is_template ? 1 : 0
      };
      const payload = qs.stringify(requestBody);
      try {
        const { data } = await post('/notification/update', {
          data: payload
        });
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadFormAnnouncement = false;
      }
    },
    async deleteAnnouncement(id) {
      this.loadFormAnnouncement = true;
      const requestBody = { notification_id: id };
      const payload = qs.stringify(requestBody);
      try {
        await post('/notification/delete', {
          data: payload
        });
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadFormAnnouncement = false;
      }
    }
  }
};
